import styled from '@emotion/styled';
import { IconAndTextButtonLink } from '@blueprint/ui';
import { css } from '@emotion/css';

const tempLargerBreakPoint = '@media only screen and (min-width: 1140px)';

export const MobileAlertPanelWrapper = styled('div')(
    ({ theme }) => css`
        display: flex;
        padding-top: 1.125rem;
        padding-bottom: 0.7rem;
        justify-content: space-evenly;
        background-color: ${theme.colors['graphic-background']};
        width: 100%;
        margin-top: -1.5rem;

        ${tempLargerBreakPoint} {
            display: none;
        }
    `
);

export const MobileText = styled('span')(
    ({ theme }) => css`
        display: inline;
        ${theme.mq.small} {
            display: none;
        }
    `
);
export const TabletText = styled('span')(
    ({ theme }) => css`
        display: none;
        ${theme.mq.small} {
            display: inline;
        }
    `
);

export const AlertPanelButtonLinkMobile = styled(IconAndTextButtonLink)(
    () => css`
        border: 0;
        display: flex;
    `
);

export const Divider = styled('span')(
    ({ theme }) => css`
        width: 0.0625rem;
        height: 2rem;
        background-color: ${theme.colors['graphic-divider']};
        display: inline-block;
    `
);
